import React from 'react';
import { TextField, MenuItem, Box } from '@mui/material';
import { OutputColumnField } from './OutputColumnField';
import { CheckBoxField } from './CheckBoxField';

export const OutputColumnSelector = ({
  transformInPlace,
  setTransformInPlace,
  setSelectedOutputSource,
  outputColumn,
  setOutputColumn,
  sourceColumns,
  headers,
  disabled,
  errors,
}) => {
  return (
    <Box sx={{ mt: 1 }}>
      <CheckBoxField
        checked={transformInPlace}
        onChange={(checked) => {
          setTransformInPlace(checked);
          if (checked) {
            setOutputColumn('');
          } else {
            setSelectedOutputSource('');
          }
        }}
        disabled={disabled}
        label="Use source column as output"
      />

      {transformInPlace ? (
        <TextField
          select
          fullWidth
          label="Select Output Column *"
          value={outputColumn}
          onChange={(e) => {
            setSelectedOutputSource(e.target.value);
            setOutputColumn(e.target.value);
          }}
          disabled={disabled}
          size="small"
          error={!!errors.selectedOutputSource}
          helperText={errors.selectedOutputSource || 'Select which source column to use as output'}
        >
          {sourceColumns
            .filter((col) => col)
            .map((col, index) => (
              <MenuItem key={index} value={col}>
                {headers.find((h) => h.label === col)?.label || col}
              </MenuItem>
            ))}
        </TextField>
      ) : (
        <OutputColumnField
          value={outputColumn}
          onChange={(e) => setOutputColumn(e.target.value)}
          disabled={disabled}
          error={!!errors.outputColumn}
        />
      )}
    </Box>
  );
};
